import type { MessageDescriptor } from 'react-intl';

export enum ChecklistItemId {
	writeStatusUpdate = 'writeStatusUpdate',
	connectWorkTools = 'connectWorkTools',
	askRovoFind = 'askRovoFind',
	deepResearch = 'deepResearch',
	promptGallery = 'promptGallery',
	browseAgents = 'browseAgents',
	automateWork = 'automateWork',
	installExtension = 'installExtension',
}

export type ChecklistItem = {
	id: ChecklistItemId;
	iconLight: () => JSX.Element;
	iconDark: () => JSX.Element;
	label: MessageDescriptor;
	/** Shown under the title on the full-width checklist card */
	description: MessageDescriptor;
	labelValues?: Record<string, string>;
};

export type ChecklistItemCompletedFromTraits = {
	[key in ChecklistItemId]: boolean;
};

export type ConnectorProvider = {
	providerType: string;
	displayName: string;
};

export type ConnectorRecommendation = {
	provider: ConnectorProvider;
	outboundAuthUrl: string;
};

export type RecentJiraProjectInfo = {
	isProjectAdmin: boolean;
	jiraProjectKey: string;
	jiraProjectWebUrl: string;
};
